import { memo, useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import { errorResponseMessages } from "api/apiErrorHelper";
import PageHeader from "ui/PageHeader/PageHeader";
import { ModerationsData } from "features/moderation/types/ModerationsData";
import Button from "ui/Buttons/Button";

import {
  getModerations,
  updateModeration,
} from "features/moderation/api/moderationsApi";

import Wrapper from "ui/Wrapper/Wrapper";
import { ColumnsType } from "antd/lib/table";
import Table from "ui/Table/Table";

const ModerationsScreen = () => {
  const [moderations, setModerations] = useState<ModerationsData[]>([]);
  const [tableLoading, setTableLoading] = useState<boolean>(true);
  const [pagination, setPagination] = useState<object>({
    simple: true,
    current: 1,
    pageSize: 10,
    total: 0,
  });

  // https://app.zoop.club/instalando_oficial/post/4247

  const getModerationApi = async () => {
    setTableLoading(true);

    const { currentTotal } = pagination as any;
    const response = await getModerations({ ...pagination });
    const { rows, count } = response;

    setModerations(rows);
    setTableLoading(false);

    if (currentTotal !== count) {
      setPagination((prev) => ({
        ...prev,
        total: count,
      }));
    }
  };

  const handleTableChange = (pagination) => {
    setPagination({
      current: pagination.current,
      pageSize: pagination.pageSize,
      total: pagination.total,
    });
  };

  const { current = 1 } = pagination as any;

  const handleChange = ({ id, hideInFeed }) => {
    try {
      updateModeration({ id, hideInFeed: !hideInFeed });
      const updatedModerations = moderations.map((item) => {
        if (item.id === id) {
          return { ...item, hideInFeed: !hideInFeed };
        }
        return item;
      });

      setModerations(updatedModerations);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!tableLoading || moderations.length === 0) {
      getModerationApi();
    }
  }, [current]);

  const columns: ColumnsType = [
    {
      title: "post id",
      dataIndex: "postId",
      key: "postId",
      render: (postId) => {
        return <span>{postId}</span>;
      },
    },
    {
      title: "card id",
      dataIndex: "cardId",
      key: "cardId",
      render: (text) => <span>{text || "-"}</span>,
    },
    {
      title: "Type",
      dataIndex: "fileType",
      key: "fileType",
      render: (text) => <span>{text || "-"}</span>,
    },
    {
      title: "File",
      dataIndex: "fileLink",
      key: "fileLink",
      render: (text) => {
        return (
          <span>
            <a href={text} target="_blank" rel="noopener noreferrer">
              {text}
            </a>
          </span>
        );
      },
    },
    {
      title: "Moderation",
      dataIndex: "moderation",
      key: "moderation",
      render: (text) => {
        if (!text) return <span>-</span>;
        const value = Object.keys(text).join(", ");
        return <span>{value}</span>;
      },
    },
    {
      title: "Created",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => <span>{text || "-"}</span>,
    },
    {
      title: "Action",
      key: "hideInFeed",
      render: (item) => {
        const { id, hideInFeed } = item as ModerationsData;
        const title = Boolean(hideInFeed) ? "Unblock" : "Block";

        return (
          <span>
            <Button
              type="primary"
              style={{
                backgroundColor: Boolean(hideInFeed) ? "green" : "red",
                color: "white",
              }}
              onClick={() => {
                handleChange({ id, hideInFeed });
              }}
            >
              {title}
            </Button>
          </span>
        );
      },
    },
  ];

  return (
    <>
      <PageHeader title={"Moderations"} />
      <Wrapper>
        <Table
          loading={tableLoading}
          columns={columns}
          dataSource={moderations}
          exportableDataTableName={`Moderations`}
          showColumnPicker={true}
          onChange={handleTableChange}
          pagination={pagination}
        />
      </Wrapper>
    </>
  );
};

export default memo(ModerationsScreen);
